import { render, staticRenderFns } from "./LeadsListFilters.vue?vue&type=template&id=28852f12&"
import script from "./LeadsListFilters.vue?vue&type=script&lang=js&"
export * from "./LeadsListFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports